import UltMeta, { Meta } from "@/meta/UltMeta/index";
// 对账状态
class ReconciliationState extends UltMeta {
    NOT_RECONCILIATION = new Meta(1, "未对账", "color-black");
    RECONCILING = new Meta(2, "对账中", "color-black");
    RECONCILED = new Meta(3, "已对账", "color-info");
}
export const RECONCILIATION_STATE = new ReconciliationState();

// 签收状态
class ReceiptState extends UltMeta {
    CONFIRMING = new Meta(2, "签收中", "color-black");
    FINISHED = new Meta(4, "已完成", "color-info");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}
export const RECEIPT_STATE = new ReceiptState();

class ReceiptType extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "直采-采购商");
    DOWNSTREAM_MIDSTREAM = new Meta(2, "联合采购-采购商");
    MIDSTREAM_UPSTREAM = new Meta(3, "联合采购-联合购销商");
}
export const RECEIPT_TYPE = new ReceiptType();

class ReconciliationType extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "供应商-采购商");
    DOWNSTREAM_MIDSTREAM = new Meta(3, "联合购销商-采购商");
    MIDSTREAM_UPSTREAM = new Meta(2, "供应商-联合购销商");
}
export const RECONCILIATION_TYPE = new ReconciliationType();
